import React from "react";
import { Gavel } from "@mui/icons-material";
import LegalDocumentPage from "./LegalDocumentPage";
import { TOS_URL } from "./TermsOfServiceModal";

// The same text the TermsOfServiceModal gate shows after login, as a public page so it can be
// read before signing up.
export default function TermsOfUsePage() {
    return <LegalDocumentPage url={TOS_URL} title="Terms of Use" Icon={Gavel} />;
}
